import { Box, styled, Typography } from '@mui/material';

import BancoValorBgLoginPage from '../../../assets/img/BVALOR_bg-login.webp';
import BancoValorBgLPage from '../../../assets/img/BVALOR_bg-lpage.webp';

export const BoxBackgroundImageStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLoginPage',
})(({ isLoginPage }) => ({
  backgroundImage: `url(${
    isLoginPage ? BancoValorBgLoginPage : BancoValorBgLPage
  })`,
  backgroundPosition: 'top',
  width: isLoginPage ? '50%' : '100%',
  height: isLoginPage ? '100%' : 'fill-available',
  minHeight: isLoginPage ? 'auto' : '650px',
  backgroundSize: 'cover',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
}));

export const BackgroundMobileImageStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLoginPage',
})(({ theme, isLoginPage }) => ({
  width: '100%',
  height: isLoginPage ? '216px' : 'fill-available',
  minHeight: '216px',
  objectFit: 'cover',

  [theme.breakpoints.up('md')]: {
    height: isLoginPage && '416px',
    minHeight: '416px',
  },
}));

export const LandingPageText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLoginPage',
})(({ theme, isLoginPage }) => ({
  width: '328px',
  color: theme.palette.colors.onHomePageBackground,
  fontSize: '34px',
  fontWeight: 700,
  lineHeight: 1.18,
  letterSpacing: 'normal',
  marginInline: 'auto',
  padding: '16px 0',
  display: isLoginPage && 'none',

  [theme.breakpoints.up('sm')]: {
    width: '417px',
  },
  [theme.breakpoints.up('md')]: {
    width: '550px',
  },
  [theme.breakpoints.up('lg')]: {
    display: isLoginPage && 'block',
    width: 'auto',
    maxWidth: !isLoginPage && '650px',
    color: theme.palette.colors.onImageBackground,
    fontSize: '40px',
    lineHeight: 1.15,
    margin: 0,
    padding: 0,
  },
  [theme.breakpoints.up('xxl')]: {
    maxWidth: !isLoginPage && '626px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    maxWidth: !isLoginPage && '967px',
  },
}));

export const CardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLoginPage',
})(({ theme, isLoginPage }) => ({
  backgroundColor: theme.palette.colors.homePageBackground,
  width: '100%',
  height: !isLoginPage && 'fill-available',
  display: 'flex',
  flexDirection: 'column',
  position: isLoginPage && 'relative',
}));
